// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IBillingDryRunLineDto } from './billing-dry-run-line-dto.g';
import { IBillingStorageUsageDto } from './billing-storage-usage-dto.g';

export const billingDryRunDto = {
    domainGuid: 'domainGuid',
    domainName: 'domainName',
    period: 'period',
    billable: 'billable',
    currentMonth: 'currentMonth',
    total: 'total',
    charged: 'charged',
    storageUsages: 'storageUsages',
    lines: 'lines',
} as const;

export type TBillingDryRunDto = (typeof billingDryRunDto)[keyof typeof billingDryRunDto];

export interface IBillingDryRunDto {
    [billingDryRunDto.domainGuid]: string | null;
    [billingDryRunDto.domainName]: string | null;
    [billingDryRunDto.period]: string | null;
    [billingDryRunDto.billable]: boolean | null;
    [billingDryRunDto.currentMonth]: boolean | null;
    [billingDryRunDto.total]: number | null;
    [billingDryRunDto.charged]: number | null;
    [billingDryRunDto.storageUsages]: IBillingStorageUsageDto[] | null;
    [billingDryRunDto.lines]: IBillingDryRunLineDto[] | null;
}

export class BillingDryRunDto
    implements IBillingDryRunDto
{
    [billingDryRunDto.domainGuid]: string | null = null;
    [billingDryRunDto.domainName]: string | null = null;
    [billingDryRunDto.period]: string | null = null;
    [billingDryRunDto.billable]: boolean | null = null;
    [billingDryRunDto.currentMonth]: boolean | null = null;
    [billingDryRunDto.total]: number | null = null;
    [billingDryRunDto.charged]: number | null = null;
    [billingDryRunDto.storageUsages]: IBillingStorageUsageDto[] | null = null;
    [billingDryRunDto.lines]: IBillingDryRunLineDto[] | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IBillingDryRunData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[billingDryRunDto.guid] = modelData[billingdryrunData.guid];
    }

    static create(modelData?: any | null): IBillingDryRunDto | null {
        return modelData ? new BillingDryRunDto(modelData) : null;
    }
}
